import { IDefineCommand } from 'core-ts-types';
import { AccountModel } from 'data-ng-authentication';
import * as _4 from 'lodash4';
import { ORM } from 'utility-ts-orm';
import { APStudentDetailsQuery } from '../../global/components/student_details/queries/student_details_query';
import { IAPAvailableTermsDatasource } from '../../global/datasources/ap_available_terms_datasource';
import { IAPMultiTermDatasource } from '../../global/datasources/ap_multi_student_term_datasource';
export interface INewPlannedTerm {
  id: number;
  nk: string;
  term_data: INewTermData;
}
interface INewTermData {
  cat_yr: number;
  id: number;
  name: string;
}
angular
  .module('capability-ng-academic-planner')
  .service(
    'addMmTermCommand',
    function addMmTermCommandDefinition(
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      accountModel: AccountModel,
      ngAPStudentDetailsQuery: APStudentDetailsQuery,
      ngAPMultiTermDatasource: IAPMultiTermDatasource,
      ngAPAvailableTermsDatasource: IAPAvailableTermsDatasource,
      log: any
    ) {
      return defineCommandORM('addMmTermCommand', function addMmTermCommand(deferred, termId: number) {
        const studentNk = _4.get(accountModel, 'student_nk', 0) || _4.get(ngAPStudentDetailsQuery, 'result.id', 0);
        $http
          .post(`academicplan/students/${studentNk}/student_planned_terms`, { term: termId })
          .then((response: ng.IHttpPromiseCallbackArg<INewPlannedTerm>) => {
            ngAPAvailableTermsDatasource.del(termId);
            deferred.resolve(studentNk);
          })
          .catch((e) => {
            log.issue('failed to save term, please try again');
            deferred.reject(e.data);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/commands/add_mm_term_command.ts